import { Link } from 'react-router-dom';
import { navLinks, site } from '@/mocks/site';

const categoryLinks = [
  { label: '娱乐圈料核实', to: '/ranking?category=entertainment' },
  { label: '商界传闻核实', to: '/ranking?category=business' },
  { label: '网络传言核实', to: '/ranking?category=rumor' },
  { label: '科技圈动态核实', to: '/ranking?category=tech' },
  { label: '社会热点核实', to: '/ranking?category=society' },
];

const verdictLinks = [
  { label: '实锤成立', to: '/ranking?verdict=confirmed' },
  { label: '部分属实', to: '/ranking?verdict=partial' },
  { label: '已辟谣', to: '/debunk' },
  { label: '仍在核实', to: '/ranking?verdict=pending' },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-0 bg-secondary-950 text-background-200">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">{site.intro}</p>
            <p className="mt-4 text-sm text-background-400">{site.tagline}</p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/ranking" className="hover:text-primary-300 transition-colors">
                按分类浏览
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              {categoryLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-300 hover:text-background-50 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/ranking" className="hover:text-primary-300 transition-colors">
                按判定浏览
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              {verdictLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-300 hover:text-background-50 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-primary-300 transition-colors">
                关于与联系
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              {navLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-300 hover:text-background-50 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-4 space-y-2 text-sm text-background-300">
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                {site.email}
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                投稿：{site.submitEmail}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {site.name} · 热料核实情报站 · {site.updateNote}</p>
          <p className="sm:text-right">
            本站内容为公开信息整理与核实记录，如判定有误欢迎通过投稿纠错渠道指正。
          </p>
        </div>
      </div>
    </footer>
  );
}